var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClubHouseWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ClubHouse_White",
    xmlns: "http://www.w3.org/2000/svg",
    width: 225.605,
    height: 225.615,
    viewBox: "0 0 225.605 225.615",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #f5f5f5;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_65",
    "data-name": "Path 65",
    className: "cls-1",
    d: "M225.616,42.964a9.923,9.923,0,0,0-9.911-9.918H172.294V19.26A9.918,9.918,0,0,0,168.987,0H56.62a9.918,9.918,0,0,0-3.3,19.267V33.049H9.906A9.918,9.918,0,0,0,6.6,52.308v150.18a3.308,3.308,0,0,0,3.308,3.3H73.142l-18.5,13.88a3.308,3.308,0,0,0,1.98,5.949H168.985a3.308,3.308,0,0,0,1.987-5.949l-18.5-13.88H215.7a3.308,3.308,0,0,0,3.3-3.3h0V52.306a9.918,9.918,0,0,0,6.615-9.342ZM172.3,52.876h40.1V165.243h-40.1ZM56.62,6.608H168.987a3.308,3.308,0,1,1,0,6.608H69.839a3.308,3.308,0,0,0,0,6.608H165.7V199.172h-6.624V128.893a3.307,3.307,0,0,0-3.308-3.319H69.839a3.308,3.308,0,0,0-3.3,3.308v70.324H59.923V16.509A3.308,3.308,0,0,0,56.616,13.2h0a3.308,3.308,0,0,1,0-6.608Zm59.491,192.6V158.632h23.128v40.543Zm-29.745,0V158.632H109.5v40.543Zm56.183-47.151H83.062a3.308,3.308,0,0,0-3.308,3.308h0v43.843H73.147V132.194h79.323v66.981h-6.613V155.331a3.308,3.308,0,0,0-3.308-3.308ZM53.317,52.876V165.243h-40.1V52.876ZM9.906,39.657H53.317v6.608H9.906a3.308,3.308,0,1,1,0-6.608Zm3.31,132.194h40.1v27.326h-40.1ZM159.069,219H66.536l17.628-13.219h57.284Zm13.219-19.827V171.851h40.1v27.326ZM215.7,46.265H172.288V39.657H215.7a3.308,3.308,0,0,1,0,6.608Z",
    transform: "translate(-0.011)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_66",
    "data-name": "Path 66",
    className: "cls-1",
    d: "M35.729,143.58h20.28a3.308,3.308,0,0,0,3.308-3.307V100.6a3.308,3.308,0,0,0-3.308-3.308H35.729a3.308,3.308,0,0,0-3.3,3.308h0v39.657a3.308,3.308,0,0,0,3.3,3.325Zm3.308-39.657H52.695v33.046H39.041Z",
    transform: "translate(-12.613 -37.806)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67",
    "data-name": "Path 67",
    className: "cls-1",
    d: "M316.177,97.29H295.9a3.308,3.308,0,0,0-3.3,3.308h0v39.657a3.307,3.307,0,0,0,3.3,3.325h20.276a3.308,3.308,0,0,0,3.3-3.307V100.6a3.307,3.307,0,0,0-3.3-3.308Zm-3.308,39.664H299.211V103.936h13.658Z",
    transform: "translate(-113.706 -37.806)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_68",
    "data-name": "Path 68",
    className: "cls-1",
    d: "M35.729,230.045h20.28a3.308,3.308,0,0,0,3.308-3.3V187.081a3.308,3.308,0,0,0-3.308-3.3H35.729a3.3,3.3,0,0,0-3.3,3.3v39.664A3.3,3.3,0,0,0,35.729,230.045Zm3.308-39.657H52.695v33.017H39.041Z",
    transform: "translate(-12.613 -71.413)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69",
    "data-name": "Path 69",
    className: "cls-1",
    d: "M316.177,183.78H295.9a3.3,3.3,0,0,0-3.3,3.3v39.664a3.3,3.3,0,0,0,3.3,3.3h20.276a3.3,3.3,0,0,0,3.3-3.3V187.081A3.3,3.3,0,0,0,316.177,183.78Zm-3.308,39.657H299.211V190.42h13.658Z",
    transform: "translate(-113.706 -71.413)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_70",
    "data-name": "Path 70",
    className: "cls-1",
    d: "M144.737,74.48H124.461a3.308,3.308,0,0,0-3.3,3.308h0v39.657a3.308,3.308,0,0,0,3.3,3.308h20.276a3.308,3.308,0,0,0,3.3-3.308V77.788A3.308,3.308,0,0,0,144.737,74.48Zm-3.305,39.664h-13.64V81.126h13.658Z",
    transform: "translate(-47.09 -28.941)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71",
    "data-name": "Path 71",
    className: "cls-1",
    d: "M229.032,75.93H208.788a3.307,3.307,0,0,0-3.307,3.3h0v39.661a3.308,3.308,0,0,0,3.308,3.308h20.244a3.308,3.308,0,0,0,3.3-3.308V79.226A3.3,3.3,0,0,0,229.032,75.93Zm-3.308,39.657H212.091V82.57h13.658Z",
    transform: "translate(-79.855 -29.506)"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClubHouseWhite);
export default __webpack_public_path__ + "static/media/ClubHouse_White.cc41900fef0a869040d59f5879a56a51.svg";
export { ForwardRef as ReactComponent };